import { each } from 'lodash';

const checkBallParity = (ball) => ball % 2 !== 0;

class Result {
  constructor(data, config) {
    this.config = config;
    this.balls = data.balls;
    this.bonusBalls = data.bonusBalls;
    this.eventId = data.eventId;
    this.preballsSum = 0;
    this.preballsSumText = null;
    this.odd = false;
  }

  reset() {
    this.preballsOddCount = 0;
    this.preballsEvenCount = 0;
    this.preballsSum = 0;
    this.preballsSumText = null;
  }

  update() {
    this.reset();
    each(this.balls, (item) => {
      if (item.id <= 5) {
        this.odd = checkBallParity(item.ball);
        this.preballsOddCount += this.odd ? 1 : 0;
        this.preballsEvenCount += this.odd ? 0 : 1;
        this.preballsSum += item.ball;

        // Set preballs parity text
        this.preballsParityText = this.preballsOddCount > this.preballsEvenCount ? 'general_odd' : 'general_even';

        // Set preballs sum text
        this.preballsSumText = this.preballsSum < this.config.bets[6].limit ? 'general_low' : 'general_high';
      }
    });
  }
}

export { Result };
